import { shirtSizeTypes } from "utils/helpers/dictionaries";

export const shirtSizeList: shirtSizeTypes[] = [
  shirtSizeTypes.s,
  shirtSizeTypes.m,
  shirtSizeTypes.l,
  shirtSizeTypes.xl
]